import React, { useEffect } from 'react';
import Helmet from 'react-helmet';

import WebsitePreviewContainer from '../WebsitePreviewContainer';

const VirtualEventPreviewLive = ({ theme, getPages, eventFormData }) => {
  const themeKey = theme.key || undefined;
  const themeFont = theme.font_name || undefined;
  const isDev =
    window.location.hostname === 'localhost' || window.location.hostname === 'qa.zola.com';
  const cloudfront = isDev
    ? 'https://d2wzwlp3rxwsn1.cloudfront.net'
    : 'https://d2gt2lt628wbyx.cloudfront.net';

  useEffect(() => {
    getPages();
  }, []);

  return (
    <React.Fragment>
      <Helmet
        link={[
          {
            rel: 'stylesheet',
            href: `https://fonts.googleapis.com/css?family=${themeFont}`,
          },
          {
            rel: 'stylesheet',
            href: `${cloudfront}/${themeKey}.css`,
          },
        ]}
      />
      <WebsitePreviewContainer pageComponentKey="VIRTUAL_EVENT" eventFormData={eventFormData} />
    </React.Fragment>
  );
};

export default VirtualEventPreviewLive;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomEdit/components/VirtualEventPreviewLive/VirtualEventPreviewLive.jsx